import { ChunkDataService } from "../ChunkDataService.js";
import { ChunkHttpService } from "../httpService/ChunkHttpService.js";
import { ChunksStoreManager, MergedChunksStoreManager } from "./StoreManager/managers.js";


export class IndexedDBChunkService extends ChunkDataService {
    constructor(req, conf, gudhub) {
      super(req, conf);
  
      this.dataService = new ChunkHttpService(req);

      this.requestCache = new Map;


      this.gudhub = gudhub;

      this.storeManager = new MergedChunksStoreManager;
    }

    static [Symbol.hasInstance](instance) {
      try {
        if (instance instanceof IndexedDBChunkService) return true;
        // if (instance instanceof IndexedDBService) return true; //TODO requires multiple inheritance, thhink how to overcome it
        return false;
      } catch (error) {
        return false;
      }
    }

    async getCachedMergedChunk(id, chunkHashesList) {
      try {
        let cachedData = await this.storeManager.get(id);

        return cachedData.mergedData;
      } catch (error) {
        const requests = chunkHashesList.map(hash => this.dataService.getChunk(id, hash));
    
        const newChunks = await Promise.all(requests);


        let mergedData = await this.gudhub.util.mergeChunks(newChunks);

        this.putMergedChunks(id, {hashes: chunkHashesList, mergedData: {items_list: mergedData}});

        return {items_list: mergedData};
      }
    }

    isWithCache() {
      return true;
    }


    async getMergedChunkForApp(id) {
      // here request api and get chunks list

      //then perform all required checks for cached chunk and hashes and new hashes
    }

    //here // TODO replace this with getMergedChunkForApp in future
    async getMergedChunkForIDList(id, chunkHashesList) {
      try {

        
        let isCachedValid = true;

        let cachedData = await this.storeManager.get(id);


        try {

          if (chunkHashesList.length < cachedData.hashes.length) throw new Error;

          for (let hash of cachedData.hashes) {
            if (
              chunkHashesList.indexOf(hash) != cachedData.hashes.indexOf(hash)
            ) isCachedValid = false;
          }
        } catch (error) {
          isCachedValid = false;
        }





        if (
          !isCachedValid
        ) {
          // todo reload all data
        }



        let newChunkHashes = [];
        let newChunks = [];



        if (
          chunkHashesList.length > cachedData.hashes.length
        ) {
          newChunkHashes = chunkHashesList.slice(cachedData.hashes.length);
        }

        if (
          !isCachedValid
        ) {
          newChunkHashes = chunkHashesList;
        }

        if (
          newChunkHashes.length > 0
        ) {
          const requests = newChunkHashes.map(hash => this.dataService.getChunk(id, hash));
      
          newChunks = await Promise.all(requests);
        }

        let mergedData;
        if (
          !isCachedValid
        ) {
          mergedData = await this.gudhub.util.mergeChunks([
            // cachedData.mergedData,
            ...newChunks,
          ]);
        }

        if (
          isCachedValid
        ) {
          mergedData = await this.gudhub.util.mergeChunks([
            cachedData.mergedData,
            ...newChunks,
          ]);
        }


        if (
          newChunkHashes.length > 0
        ) {
          this.putMergedChunks(id, {hashes: chunkHashesList, mergedData: {items_list: mergedData}});
        }

        return {items_list: mergedData};
      } catch (error) {

        const requests = chunkHashesList.map(hash => this.dataService.getChunk(id, hash));
    
        const newChunks = await Promise.all(requests);


        let mergedData = await this.gudhub.util.mergeChunks(newChunks);

        this.putMergedChunks(id, {hashes: chunkHashesList, mergedData: {items_list: mergedData}});

        return {items_list: mergedData};
      }
    }

    async putMergedChunks(id, data) {
      return this.storeManager.put(id, data);
    }
}